/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse.jsx";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

// Data

// Dashboard components

function EditBmShapes() {
  const [bodyMeasurement, setBodyMeasurement] = useState("");
  const [title, setTitle] = useState("");
  const [imageData, setImageData] = useState([]);

  const { _id } = useParams();
  const location = useLocation();
  const fetchData = async (_id) => {
    console.log(_id, "test");
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/bodyData/getBodyDataImagesDetails?_id=${_id}`;
      const response = await axios.get(apiUrl);
      const data = await response.data;
      if (response?.data?.data?.bodyData || []) {
        setBodyMeasurement(data.data.bodyMeasurement);
        setTitle(data.data.title);
        setImageData(response.data.data);
        console.log(imageData,"AAAAAAAAAAA")
      } else {
        console.error("Invalid API response or missing data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (_id) {
      fetchData(_id);
    }
    console.log(_id, "ddddddddddddddd");
  }, [location.state?.productId, _id]);

  const handleInputChange = (e) => {
    setBodyMeasurement(e.target.value);
  };

  const handleInputChangeTitle = (e) => {
    setTitle(e.target.value);
  };

  const [_id1, set_id1] = useState("");
  const [file, setFile] = useState("");
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const area = {
      bodyMeasurement,
      title,
      file,
    };

    try {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(area),
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/updateBodyDataImages/${_id}`,
        requestOptions
      );
      // console.log(_id, "ggggggggggggggggggg");
      if (!response.ok) {
        const error = await response.text();
        throw new Error(error);
      }
      const data = await response.json();
      console.log(data, "ggggggggggggggggggggggg");
      set_id1("");
      setTitle("");
      setBodyMeasurement("");
      setFile("");
    } catch (error) {
      // setErrorMessage(error.message || "An error occurred while updating data");
      // console.error("There was an error!", error);
    }
  };

  const [showInput, setShowInput] = useState("");
  const handleDeleteImage = (index) => {
    const updatedImageData = { ...imageData };
    updatedImageData.images.splice(index, 1);
    setImageData(updatedImageData);
    setShowInput(true);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the selected file
    console.log("Selected file:", file);
    setImageData([...imageData.images,event.target.files[0]])
    // You can perform further processing like uploading the image to your server here
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          action=""
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Name*"
                value={bodyMeasurement}
                onChange={handleInputChange}
                variant="outlined"
              />

              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Type*"
                value={title}
                variant="outlined"
                onChange={handleInputChangeTitle}
              />

              {/* <TextField
                type="file"
                className="form-control"
                onChange={(e) => setFile(e.target.files[0])}
              /> */}

              {/* <div>
                {imageData && (
                  <div>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {imageData.images.map((imageUrl, index) => (
                        <div key={index} style={{ margin: "10px", position: "relative" }}>
                          <img
                            src={imageUrl}
                            alt={`Image ${index + 1}`}
                            style={{ width: "100px", height: "auto", cursor: "pointer" }}
                            onClick={() => handleDeleteImage(index)}
                          />

                          <span
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDeleteImage(index)} 
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-x-circle"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm4.354 11.354a.5.5 0 0 1 0 .708l-1.353 1.353a.5.5 0 0 1-.708 0L8 9.707l-2.293 2.293a.5.5 0 0 1-.708 0l-1.353-1.353a.5.5 0 0 1 0-.708L6.293 8 4 5.707a.5.5 0 0 1 0-.708l1.353-1.353a.5.5 0 0 1 .708 0L8 6.293l2.293-2.293a.5.5 0 0 1 .708 0l1.353 1.353a.5.5 0 0 1 0 .708L9.707 8l2.293 2.293z"
                              />
                            </svg>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div> */}

              <div>
                {imageData && (
                  <div>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      {imageData.images?.map((imageUrl, index) => (
                        <div key={index} style={{ margin: "10px", position: "relative" }}>
                          <img
                            src={imageUrl}
                            alt={`Image ${index + 1}`}
                            style={{ width: "100px", height: "auto", cursor: "pointer" }}
                            onClick={() => handleDeleteImage(index)}
                          />

                          <span
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDeleteImage(index)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-x-circle"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm4.354 11.354a.5.5 0 0 1 0 .708l-1.353 1.353a.5.5 0 0 1-.708 0L8 9.707l-2.293 2.293a.5.5 0 0 1-.708 0l-1.353-1.353a.5.5 0 0 1 0-.708L6.293 8 4 5.707a.5.5 0 0 1 0-.708l1.353-1.353a.5.5 0 0 1 .708 0L8 6.293l2.293-2.293a.5.5 0 0 1 .708 0l1.353 1.353a.5.5 0 0 1 0 .708L9.707 8l2.293 2.293z"
                              />
                            </svg>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Display the input field if showInput is true */}
                {showInput && (
                  <div>
                    <input type="file" onChange={handleImageUpload} />
                  </div>
                )}
              </div>
            </div>
            {/* <div style={{ display: "flex", gap: "40px", marginTop: "5vh" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <span style={{ fontWeight: "bold", fontSize: "0.9rem" }}>Input Type</span>
                <select
                  style={{
                    width: "20vw",
                    border: "1px solid gray",
                    outline: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    height: "7vh",
                  }}
                  name=""
                  id=""
                >
                  <option value="">Input Type</option>
                  <option value="">Radio</option>
                  <option value="">Text</option>
                  <option value="">Button</option>
                </select>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <span style={{ fontWeight: "bold", fontSize: "0.9rem" }}>Body Measurement</span>
                <select
                  style={{
                    width: "20vw",
                    border: "1px solid gray",
                    outline: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    height: "7vh",
                  }}
                  name=""
                  id=""
                >
                  <option value="">Shoulder Width</option>
                  <option value="">Chest Circumference</option>
                  <option value="">Footlength</option>
                  <option value="">test</option>
                </select>
              </div>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "5vh" }}
            >
              <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Image*</span>
              <label htmlFor="profile_pic">
                <span
                  style={{
                    background: "crimson",
                    padding: "10px",
                    borderRadius: "10px",
                    fontSize: "small",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Choose Image
                </span>
              </label>
              <input id="profile_pic" style={{ display: "none" }} type="file" />
            </div> */}
          </div>
          <div style={{ textAlign: "center", color: "red" }}>
            <span
              className="bg-red-700 rounded-md w-[10vw] cursor-pointer
             p-2 border-none outline-none ml-[1vw] text-white  text-sm"
              onClick={handleSubmit}
            >
              Submit
            </span>
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditBmShapes;
